import { z } from 'zod'

import { dbEntitySchema } from './system'

export const trackerSchema = dbEntitySchema.extend({
  name: z.string(),
  slug: z.string(),
  affiliate: z.string(),
  bookingCount: z.number().optional(),
})

export const trackerCreateArgsSchema = z.object({
  name: z.string().min(1),
  affiliateId: z.string().min(1),
})
